// === Menu === //
const navToggler = () => {
  const navToggle = document.querySelector(".menu__toggle")
  const menuMobile = document.querySelector(".mobile-menu")
  // const page = document.querySelector("body");

  if (navToggle !== null) {
  navToggle.addEventListener("click", (event) => {
      menuMobile.classList.toggle("mobile-menu--open");
      // page.classList.toggle("no-scroll");
      navToggle.classList.toggle("menu__toggle--close");
  });
  }
};
navToggler ();

// === Mobile submenu === //
const mobileSubmenu = document.querySelectorAll(".mobile-submenu");

mobileSubmenu.forEach(mobileSubmenu => {
  mobileSubmenu.addEventListener("click", () => {
    mobileSubmenu.classList.toggle("active");
    });
});


// Product slider
var swiper = new Swiper(".productSlider", {
  slidesPerView: 1,
  spaceBetween: 20,
  keyboard: {
    enabled: true,
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
    renderBullet: function (index, className) {
      return '<span class="' + className + '">' + "</span>";
    },
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
});


var swiper = new Swiper(".product-slider__thumb", {
  spaceBetween: 15,
  slidesPerView: 8,
  // freeMode: true,
  watchSlidesProgress: true,
  keyboard: {
    enabled: true,
  },
});
var swiper2 = new Swiper(".product-slider", {
  spaceBetween: 10,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  thumbs: {
    swiper: swiper,
  },
});

document.addEventListener("DOMContentLoaded", function () {
  const menu = document.querySelector(".menu-section");
  const main = document.getElementById("MainContent");

  if (menu && main) {
    const menuHeight = menu.offsetHeight;
    main.style.paddingTop = menuHeight + "px";
  }
});